// removed by extract-text-webpack-plugin
module.exports = {"ad":"styles__ad___1isGr","adBounded":"styles__adBounded___3V5Oe","adHero":"styles__adHero___3BmVy","adLabel":"styles__adLabel___1DXUD"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/ad/styles.css
// module id = uYDL
// module chunks = 2